<app-collection-form
    *ngIf="!loading"
    [title]="'pages.collections.configuration.header.title.edit' | translate"
    [collection]="collection" 
    [submitLoading]="submitLoading"
    [isEditMode]="true"
    (submitForm)="handleSubmit($event)">
</app-collection-form>